import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { useNavigate } from 'react-router-dom';

type Props = {
  opened: boolean;
  setOpened: (opened: boolean) => void;
  adminUser: boolean;
  warehouseUser: boolean;
  isHomeButtonActive: boolean;
  isVehiclesButtonActive: boolean;
  isUsersButtonActive: boolean;
  isEntitiesButtonActive: boolean;
  isVinDecoderButtonActive: boolean;
};

export default function LeftMenuDrawer(props: Props) {
  const {
    opened,
    setOpened,
    adminUser,
    warehouseUser,
    isHomeButtonActive,
    isVehiclesButtonActive,
    isUsersButtonActive,
    isEntitiesButtonActive,
    isVinDecoderButtonActive,
  } = props;

  const navigate = useNavigate();
  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setOpened(open);
  };

  return (
    <Drawer
      anchor="left"
      open={opened}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: {
          mt: { xs: '57px', sm: '65px' },
        },
      }}
    >
      <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
        <List sx={{ paddingTop: 0 }}>
          {!warehouseUser ? (
            <ListItem disablePadding divider sx={isHomeButtonActive ? { backgroundColor: '#eeeeee' } : {}}>
              <ListItemButton
                onClick={() => {
                  navigate('/home');
                }}
              >
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItemButton>
            </ListItem>
          ) : null}
          {adminUser || warehouseUser ? (
            <ListItem disablePadding divider sx={isVehiclesButtonActive ? { backgroundColor: '#eeeeee' } : {}}>
              <ListItemButton
                onClick={() => {
                  navigate('/home/vehicles');
                }}
              >
                <ListItemIcon>
                  <DirectionsCarFilledIcon />
                </ListItemIcon>
                <ListItemText primary="Vehicles" />
              </ListItemButton>
            </ListItem>
          ) : null}
          {adminUser ? (
            <>
              <ListItem disablePadding divider sx={isUsersButtonActive ? { backgroundColor: '#eeeeee' } : {}}>
                <ListItemButton
                  onClick={() => {
                    navigate('/home/users');
                  }}
                >
                  <ListItemIcon>
                    <AccountCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary="Users" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding divider sx={isEntitiesButtonActive ? { backgroundColor: '#eeeeee' } : {}}>
                <ListItemButton
                  onClick={() => {
                    navigate('/home/entities');
                  }}
                >
                  <ListItemIcon>
                    <PermContactCalendarIcon />
                  </ListItemIcon>
                  <ListItemText primary="Entities" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding divider sx={isVinDecoderButtonActive ? { backgroundColor: '#eeeeee' } : {}}>
                <ListItemButton
                  onClick={() => {
                    navigate('/home/vin-decoder');
                  }}
                >
                  <ListItemIcon>
                    <ManageSearchIcon />
                  </ListItemIcon>
                  <ListItemText primary="VIN Decoder" />
                </ListItemButton>
              </ListItem>
            </>
          ) : null}
        </List>
      </Box>
    </Drawer>
  );
}
